/*!
 * Copyright © 2026 Actavivo
 */
import * as AV from "./Interfaces/AV.Interfaces";
import { Server } from "../Platform/Server";
import { AVEntity } from "./AVEntity";

export class Game extends AVEntity {
	static _gameApi = "/api/Game";

	public static async createLeagueGame (fk: AV.IFK): Promise<AV.ILeagueGameBase> {
		return await Server.post(this._gameApi + "/CreateLeagueGame", fk);
	}

	public static async getLeagueGame (param: AV.ILeagueGameParam): Promise<AV.ILeagueGameBase> {
		return await Server.post(this._gameApi + "/GetLeagueGame", param);
	}

	public static async addTeam(param: AV.ITypeLinkParam): Promise<AV.ILeagueGameBase> {
		return await Server.post(this._gameApi + "/AddTeam", param);
	}

	public static async startGameFromGame (param: AV.ILeagueGameParam): Promise<AV.ILeagueGameBase> {
		return await Server.post( this._gameApi + "/StartGameFromGame", param);
	}

	public static async startGame(param: AV.ILeagueGameParam): Promise<AV.ILeagueGameBase> {
		return await Server.post(this._gameApi + "/StartGame", param);
	}

	public static async addScore(param: AV.IGameScoreParam): Promise<AV.ILeagueGameBase> {
		return await Server.post(this._gameApi + "/AddScore", param);
	}

	public static async deleteScore(param: AV.IGameScoreParam): Promise<AV.ILeagueGameBase> {
		return await Server.post(this._gameApi + "/DeleteScore", param);
	}

	public static async finishGame(param: AV.ILeagueGameParam): Promise<AV.ILeagueGameBase> {
		return await Server.post(this._gameApi + "/FinishGame", param);
	}
}
